<div class="container-fluid search-fountains-page py-4 px-3 px-xl-5">

  <div class="text-white rounded-3 shadow-sm p-3 mb-4  " style="background-color: #1e3a8a;">
    <h2 class="h4 mb-0 fw-bold">Búsqueda de Fuentes</h2>
  </div>

  <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="row g-2 mb-4 align-items-center search-card">
    <div class="col-12 col-lg-6">
      <input class="form-control form-control-lg" formControlName="term"
        placeholder="Buscar por código INE o nombre..." />
    </div>

    <div class="col-12 col-sm-6 col-lg-2">
      <select class="form-select form-select-lg" formControlName="status" [disabled]="isStatusFilterDisabled()"
        data-bs-toggle="tooltip" data-bs-placement="top" data-app-tooltip="true"
        title="Filtra por estado cuando el campo de búsqueda esté vacío">
        <option value="">Todos los estados</option>
        <option value="A">Activos</option>
        <option value="P">Pendientes</option>
        <option value="I">Inactivos</option>
      </select>
    </div>

    <div class="col-12 col-lg d-flex flex-wrap gap-2 search-card__actions">
      <button class="btn btn-info text-white btn-lg px-4 shadow-sm search-card__button" type="submit"
        data-bs-toggle="tooltip" data-bs-placement="top" data-app-tooltip="true"
        title="Buscar fuentes por código INE o nombre">
        <i class="bi bi-search"></i> Buscar
      </button>

      <button type="button" class="btn btn-info text-white btn-lg px-4 shadow-sm search-card__button" (click)="clearFilters()"
        data-bs-toggle="tooltip" data-bs-placement="top" data-app-tooltip="true" title="Limpiar búsqueda y filtros">
        <i class="bi bi-eraser"></i> Limpiar
      </button>

      <button type="button" class="btn btn-success btn-lg px-4 shadow-sm d-inline-flex align-items-center gap-2 search-card__button"
        (click)="exportExcel()" [disabled]="loading()" data-bs-toggle="tooltip" data-bs-placement="top"
        data-app-tooltip="true" title="Exportar todas las fuentes a Excel con todos los campos del mantenimiento">
        <i class="bi bi-file-earmark-excel"></i>
        <span>Exportar Excel</span>
      </button>

      <button type="button" class="btn btn-success btn-lg px-4 shadow-sm d-inline-flex align-items-center gap-2 export-complete-btn search-card__button"
        (click)="exportCompleteExcel()" [disabled]="loading() || exportingComplete()" data-bs-toggle="tooltip"
        data-bs-placement="top" data-app-tooltip="true"
        title="Exportar reporte completo de fuentes, articulos y caracteristicas">
        @if (exportingComplete()) {
        <span class="spinner-border spinner-border-sm"></span>
        <span>Exportando...</span>
        } @else {
        <i class="bi bi-file-earmark-spreadsheet"></i>
        <span>Exportar Excel completo</span>
        }
      </button>
    </div>
  </form>

  <div class="results-toolbar rounded-4 shadow-sm mb-4">
    <div class="d-flex flex-column flex-xl-row justify-content-between align-items-xl-center gap-3">
      <div class="d-flex flex-wrap gap-2">
        <span class="results-chip results-chip-primary">
          <i class="bi bi-funnel me-2"></i>{{ getActiveFilterSummary() }}
        </span>
        <span class="results-chip">
          <i class="bi bi-table me-2"></i>{{ getVisibleFountainsLabel() }}
        </span>
      </div>

      <p class="results-note mb-0">{{ getCompleteExportSummary() }}</p>
    </div>
  </div>

  @if (loading()) {
  <div class="text-center text-primary my-4">
    <div class="spinner-border me-2"></div>
    Cargando...
  </div>
  }

  @if (error()) {
  <div class="alert alert-danger text-center">
    {{ error() }}
  </div>
  }

  @if (fountains().length > 0) {
  <div class="fountains-grid-shell ag-theme-quartz shadow-sm rounded-4 mb-4" style="height: 550px; width: 100%;">
    <ag-grid-angular
      class="fountains-grid"
      style="width: 100%; height: 100%;"
      [rowData]="fountains()"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [pagination]="true"
      [paginationPageSize]="paginationPageSize"
      [localeText]="localeText"
      [animateRows]="true"
      (modelUpdated)="initTooltips()"
      (paginationChanged)="initTooltips()"
      (cellClicked)="onGridCellClicked($event)">
    </ag-grid-angular>
  </div>
  }

  @if (expandedSourceId()) {
    @if (selectedFountain; as fountain) {
    <div class="article-inline-panel shadow-sm rounded-4 mb-4">
      <div class="d-flex flex-column flex-xl-row justify-content-between align-items-xl-center gap-3 mb-3">
        <div>
          <p class="text-uppercase small text-secondary fw-bold mb-1">Agregar artículo a fuente</p>
          <h5 class="mb-1">{{ getSelectedFountainLabel() }}</h5>
          <p class="text-muted mb-0">
            Use este formulario para agregar artículos y características a la fuente seleccionada sin salir de búsqueda.
          </p>
        </div>

        <div class="d-flex flex-wrap gap-2 article-inline-panel__actions">
          <button type="button" class="btn btn-info text-white article-inline-panel__button" (click)="openSourceArticles(fountain)"
            data-bs-toggle="tooltip" data-bs-placement="top" data-app-tooltip="true"
            title="Ver los artículos ya guardados para esta fuente">
            <i class="bi bi-list-check me-1"></i>
            Ver agregados
          </button>

          <button type="button" class="btn btn-info text-white article-inline-panel__button" (click)="closeArticleRow()"
            data-bs-toggle="tooltip" data-bs-placement="top" data-app-tooltip="true"
            title="Cerrar el formulario y volver al listado">
            <i class="bi bi-arrow-left me-1"></i>
            Regresar
          </button>
        </div>
      </div>

      @if (articleSaveError()) {
      <div class="alert alert-danger py-2">{{ articleSaveError() }}</div>
      }

      @if (articleSaveSuccess()) {
      <div class="alert alert-success py-2">{{ articleSaveSuccess() }}</div>
      }

      <app-source-article
        [sourceId]="expandedSourceId()"
        [sourceLabel]="getSelectedFountainLabel()"
        [showAddArticleButton]="false"></app-source-article>

      <div class="d-flex flex-column flex-md-row justify-content-end gap-2 mt-3 article-inline-panel__footer-actions">
        <button type="button" class="btn btn-info text-white article-inline-panel__button" (click)="closeArticleRow()" [disabled]="articleSaving()">
          <i class="bi bi-arrow-left me-1"></i>
          Regresar
        </button>

        <button type="button" class="btn btn-info text-white article-inline-panel__button" (click)="saveExpandedArticles()" [disabled]="articleSaving()">
          @if (articleSaving()) {
          <span class="spinner-border spinner-border-sm me-2"></span>
          }
          <i class="bi bi-save me-1"></i>
          Guardar artículos en la fuente
        </button>
      </div>
    </div>
    }
  }

  @if (!loading() && hasSearched() && fountains().length === 0) {
  <div class="empty-state rounded-4 shadow-sm text-center p-5">
    <i class="bi bi-search display-6 d-block mb-3"></i>
    <h5>No se encontraron fuentes</h5>
    <p class="text-muted mb-0">Pruebe con otro código INE, nombre o estado.</p>
  </div>
  }

  <div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-fullscreen-lg-down modal-dialog-centered modal-dialog-scrollable edit-fountain-dialog">
      <div class="modal-content edit-fountain-content">
        <app-modal-edit-source
          [fountain]="selectedFountain"
          (updated)="onFountainUpdated($event)"
          (deleted)="onFountainDeleted()"></app-modal-edit-source>
      </div>
    </div>
  </div>

</div>

<div class="modal fade" id="contactsModal" tabindex="-1">
  <div class="modal-dialog modal-xl modal-fullscreen-lg-down modal-dialog-centered modal-dialog-scrollable contacts-modal-dialog">
    <div class="modal-content contacts-modal-content">

      <div class="modal-header contacts-modal-header text-white px-3 px-md-4 py-3">
        <div class="contacts-modal-title-wrap">
          <div class="contacts-modal-icon">
            <i class="bi bi-people"></i>
          </div>
          <div>
            <h5 class="modal-title mb-1 fw-semibold">Contactos de la Fuente</h5>
            <small class="contacts-modal-subtitle">
              {{ selectedFountain?.codigoINE || 'Sin código' }} · {{ selectedFountain?.nombre || selectedFountain?.razonSocial || 'Fuente seleccionada' }}
            </small>
          </div>
        </div>

        <div class="d-flex align-items-center gap-2 ms-auto contacts-modal-header-actions">
          @if (!addingContact()) {
          <button type="button"
            class="btn btn-info text-white btn-sm d-inline-flex align-items-center gap-2 px-3 shadow-sm btn-add-contact contacts-header-btn"
            (click)="openAddContactInline()" data-bs-toggle="tooltip" data-bs-placement="left" data-app-tooltip="true"
            title="Agregar un nuevo contacto a esta fuente">
            <i class="bi bi-person-plus"></i>
            <span>Agregar contacto</span>
          </button>
          } @else {
          <button type="button"
            class="btn btn-info text-white btn-sm d-inline-flex align-items-center gap-2 px-3 btn-add-contact contacts-header-btn"
            (click)="cancelAddContact()" data-bs-toggle="tooltip" data-bs-placement="left" data-app-tooltip="true"
            title="Volver al listado de contactos">
            <i class="bi bi-arrow-left"></i>
            <span>Volver</span>
          </button>
          }

          <button type="button" class="btn-close btn-close-white contacts-modal-close"
            data-bs-dismiss="modal" aria-label="Cerrar" data-bs-toggle="tooltip" data-bs-placement="left"
            data-app-tooltip="true" title="Cerrar ventana de contactos"></button>
        </div>
      </div>

      <div class="modal-body contacts-modal-body px-3 px-md-4 py-3 py-md-4">
        <div class="contacts-modal-summary">
          <div class="contacts-modal-summary-item">
            <span class="contacts-modal-summary-label">Fuente</span>
            <strong>{{ selectedFountain?.nombre || selectedFountain?.razonSocial || 'Sin dato' }}</strong>
          </div>
          <div class="contacts-modal-summary-item">
            <span class="contacts-modal-summary-label">Código</span>
            <strong>{{ selectedFountain?.codigoINE || 'Sin código' }}</strong>
          </div>
          <div class="contacts-modal-summary-item">
            <span class="contacts-modal-summary-label">Contactos visibles</span>
            <strong>{{ contacts().length }}</strong>
          </div>
        </div>

        @if (addingContact()) {
        <section class="contacts-section">
          <h6 class="contacts-section-title">
            {{ editingContact() ? 'Editar contacto' : 'Nuevo contacto' }}
          </h6>

          <form [formGroup]="form" class="row g-3">
            <div class="col-md-6">
              <label class="form-label fw-semibold">Nombre <span class="text-danger">*</span></label>
              <input class="form-control form-control-lg" formControlName="name">
              @if (form.get('name')?.touched && form.get('name')?.invalid) {
              <small class="text-danger">El nombre es obligatorio</small>
              }
            </div>

            <div class="col-md-6">
              <label class="form-label fw-semibold">Título</label>
              <input class="form-control form-control-lg" formControlName="title">
            </div>

            <div class="col-md-6">
              <label class="form-label fw-semibold">Cargo</label>
              <input class="form-control form-control-lg" formControlName="position">
            </div>

            <div class="col-md-6">
              <label class="form-label fw-semibold">Teléfonos</label>
              <input class="form-control form-control-lg" formControlName="phones">
            </div>

            <div class="col-md-6">
              <label class="form-label fw-semibold">Correo electrónico</label>
              <input class="form-control form-control-lg" formControlName="email">
              @if (form.get('email')?.touched && form.get('email')?.invalid) {
              <small class="text-danger">Correo inválido</small>
              }
            </div>

            <div class="col-md-6">
              <label class="form-label fw-semibold">Orden</label>
              <input type="number" class="form-control form-control-lg" formControlName="order" min="0">
            </div>

            <div class="col-md-6">
              <label class="form-label fw-semibold">Estado</label>
              <select class="form-select form-select-lg" formControlName="status">
                <option value="A">Activo</option>
                <option value="I">Inactivo</option>
              </select>
            </div>

            <div class="col-12">
              <label class="form-label fw-semibold">Comentarios</label>
              <textarea rows="3" class="form-control form-control-lg" formControlName="comments"></textarea>
            </div>
          </form>

          <div class="contacts-section-actions d-flex justify-content-end gap-2 mt-3">
            <button type="button" class="btn btn-danger text-white contacts-action-btn" (click)="cancelAddContact()">
              <i class="bi bi-arrow-left"></i>
              Cancelar
            </button>

            <button type="button" class="btn btn-info text-white contacts-action-btn"
              [disabled]="isAdding || form.invalid || !(selectedFountain?.id ?? selectedFountain?.pk)"
              (click)="addContact()" data-bs-toggle="tooltip" data-bs-placement="top" data-app-tooltip="true"
              [title]="editingContact() ? 'Guardar cambios del contacto' : 'Guardar el nuevo contacto en la lista'">
              <i class="bi" [class.bi-plus-circle]="!editingContact()" [class.bi-check-circle]="!!editingContact()"></i>
              {{ editingContact() ? 'Guardar cambios' : 'Agregar a la lista' }}
            </button>
          </div>
        </section>
        } @else {
        <section class="contacts-section">
          <h6 class="contacts-section-title">Contactos</h6>

          @if (loadingContacts()) {
          <div class="text-center text-primary py-3">
            <div class="spinner-border spinner-border-sm me-2"></div>
            Cargando contactos...
          </div>
          }

          @if (!loadingContacts() && contacts().length === 0) {
          <p class="text-muted text-center mb-0">No hay contactos.</p>
          }

          @if (contacts().length > 0) {
          <div class="contacts-grid-shell ag-theme-quartz">
            <ag-grid-angular
              class="contacts-grid"
              style="width: 100%; height: 100%;"
              [rowData]="visibleContacts()"
              [columnDefs]="contactColumnDefs"
              [defaultColDef]="contactDefaultColDef"
              [pagination]="true"
              [paginationPageSize]="contactPaginationPageSize"
              [localeText]="localeText"
              [animateRows]="true"
              (modelUpdated)="initTooltips()"
              (paginationChanged)="initTooltips()"
              (cellClicked)="onContactGridCellClicked($event)">
            </ag-grid-angular>
          </div>
          }
        </section>
        }
      </div>

      <div class="modal-footer contacts-modal-footer px-3 px-md-4 py-3">
        <button class="btn btn-danger text-white contacts-action-btn" data-bs-dismiss="modal" data-bs-toggle="tooltip"
          data-bs-placement="top" data-app-tooltip="true" title="Cerrar ventana de contactos">
          <i class="bi bi-x-circle"></i>
          Cerrar
        </button>
      </div>

    </div>
  </div>
</div>
